import React, { useEffect, useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal } from "reactstrap";
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Input as BaseInput } from '@mui/base/Input';
import { addLogisticsHistory, fetchInvoiceForLogisticsList, fetchInvoiceForLogisticsListByCustomId } from "../../../api/po";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import { useDispatch } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";

const blue = {
    100: '#DAECFF',
    200: '#b6daff',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
};

const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};

const InputElement = styled('input')(
    ({ theme }) => `
    width: 120px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 4px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 4px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
        };
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    }
  
    // firefox
    &:focus-visible {
      outline: 0;
    }
  `,
);
const Logistic = () => {

    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('Logistics'))
    const [vTypeList, setVTypeList] = useState([
        {label: 'Import', value: 'Import'},
        {label:'Domestic', value: 'Domestic'}
    ]);
    const [selectedVType, setSelectedVType] = useState(null);
    const [showList, setShowList] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [invoiceList, setInvoiceList] = useState([]);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [selectedDutyFeesNumber, setSelectedDutyFeesNumber] = useState(null);
    const [approvalrows, setApprovalrows] = useState([]);
    const [dutyFeesList, setDutyFeesList] = useState([]);
    const [options, setOptions] = useState({
        lr_no: '',
        lr_no_error: '',
        v_no: '',
        v_no_error: ''
    });

    const [lrNoSet, setLRNoSet] = useState(null);

    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
    const [message, setMessage] = useState("Successfully created the Custom");
    const [payload, setPayload] = useState(null);
    const [isSubmitModalOpen, setSubmitModalOpen] = useState(false)
    const [isLoading, setIsLoading] = useState(false);

    const handleInputChange = (value, input_name, index = null) => {
        if(index == null){
            let prev = {...options};
            prev[input_name] = value;
            setOptions(prev);
        } else {
            let rows = [...approvalrows];
            rows[index][input_name] = value; 

            if(input_name == 'received_qty'){
                rows[index]['remaining'] = Number(rows[index]['Quantity'])  - Number(rows[index]['received_qty']) ;
            }

            setApprovalrows(rows);
        }
        
    }

    const handleButtonClick = () => {
        setModalIsOpen(true);
    };
    const closeModal = () => {
        setModalIsOpen(false);
    };
    const toggleList = () => {
        setShowList(!showList);
    };
    const Input = React.forwardRef(function CustomInput(props, ref) {
        return <BaseInput slots={{ input: InputElement }} {...props} ref={ref} />;
    });
    document.title = "Logistics";

        const columns = [
            {
                field: 'Sl_No', headerName: 'Sl.No', flex: .5,
                resizable: false,
                sortable: false,
            },
            {
                field: 'Product_Name',
                headerName: 'Item Name',
                headerClassName: 'break-header',
                cellClassName: 'product_name_wrap',
                width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
            },
            {
                field: 'Quantity',
                headerName: 'Total QTY',
                headerClassName: 'table-header-background',
                // width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
            },
            {
                field: 'received_qty',
                headerName: 'Pickup QTY',
                headerClassName: 'table-header-background',
                // width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                renderCell: (params) => {
                    return (
                        <div className="mt-1 mb-1" style={{ cursor: 'pointer' }}>
                            <TextField
                                className="invoice_field"
                                // id={`quantity-${index}`}
                                
                                variant="outlined"
                                type='number'
                                value={params.value}
                                
                                // disabled={row.productName == ''}
                                onChange={(event) => {
                                    if(event.target.value >= 0 && event.target.value <= params.row.Quantity){
                                    
                                    handleInputChange(event.target.value, 'received_qty', params.row.Sl_No -1)
                                    }

                                }}
                                sx={{ width: 100 }}
                            />
                        </div>
                    );
                },
            },
            {
                field: 'remaining',
                headerName: 'Remain QTY',
                headerClassName: 'table-header-background',
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                // width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
            },   
        ];


        const fetchInvoiceForLogisticsListFromBackend = async (v_type) => {
            try {

    
              const response = await fetchInvoiceForLogisticsList(v_type);

              let formattedInvoices = response.data.invoiceList.map(el => ({
                invoice_id: el.id,
                invoice_number: el.invoice_number,
                label: el.invoice_number,
                v_type: el.v_type,
                dutyFees: el?.procurementCustomsDetails?.map(el => ({...el, label: el.duty_fees_no})),
                products: el?.procurementInvoiceProducts,
                ...el
              }));

              setInvoiceList(formattedInvoices);

              setLRNoSet(new Set(response.data.setData));
    
            } catch (error) {
              toast.error("Error in fetching invoice data");
              console.log(error);
            }
          };


          useEffect(() => {
            if(selectedVType){
                fetchInvoiceForLogisticsListFromBackend(selectedVType?.value)
            }
            else{
                setInvoiceList([]);
            }
          }, [selectedVType]);


          const handleSubmit = async () => {
            try {
                let hasError = false;
                let newOptions = {...options};
                if(!newOptions.lr_no){
                    newOptions.lr_no_error = 'LR No is required!';
                    hasError = true;
                } else if(lrNoSet && lrNoSet.has(newOptions.lr_no)){
                    newOptions.lr_no_error = 'LR No already exists!';
                    hasError = true;
                }
    
                if(!newOptions.v_no){
                    newOptions.v_no_error = 'Vehicle number is required!';
                    hasError = true;
                }

                // if(!newOptions.pickup_date){
                //     newOptions.pickup_date_error = 'Pickup date is required!';
                //     hasError = true;
                // }
    
                if(hasError){
                    setOptions(newOptions);
                    return;
                }
    
    
               
               let data;
                if(selectedInvoice.v_type == "Domestic"){
                    data = {
                        invoice_id: selectedInvoice.invoice_id,
                        lr_no: options.lr_no,
                        vehicle_no: options.v_no,
                        pickup_date: dayjs().format('YYYY-MM-DD'),
                        v_type: selectedInvoice.v_type,
                        logistics_product: approvalrows.map(el => ({
                            item_no: el.Product_No,
                            item_name: el.Product_Name,
                            displayed_qty: el.Quantity,
                            pickup_qty: el.received_qty,
                            remaining_qty: el.remaining,
                            invoice_product_id: el.id
                        }))
                    };
                } else {
                    data = {
                        customs_id: selectedDutyFeesNumber.id,
                        invoice_id: selectedInvoice.invoice_id,
                        duty_fees_no: selectedDutyFeesNumber.duty_fees_no,
                        lr_no: options.lr_no,
                        vehicle_no: options.v_no,
                        pickup_date: dayjs().format('YYYY-MM-DD'),
                        v_type: selectedInvoice.v_type,
                        logistics_product: approvalrows.map(el => ({
                            customs_product_id: el.id,
                            item_no: el.Product_No,
                            item_name: el.Product_Name,
                            displayed_qty: el.Quantity,
                            pickup_qty: Number(el.received_qty),
                            remaining_qty: el.remaining,
                            invoice_product_id: el.id 
                        }))
                    };
                }

                data.logistics_product = data.logistics_product.filter(el => el.pickup_qty > 0);

                if(data.logistics_product.length == 0){
                    toast.error("Add atleast 1 Pickup Qty to Submit!");
                    return;
                }

                setPayload(data);
                setSubmitModalOpen(data);
    
            } catch (error) {
                toast.error("Error in submitting invoice data");
                console.log(error);
            }
        }

        const submitRequisition = async () => {
            try {
                setIsLoading(true)
    
                
                const response = await addLogisticsHistory(payload);

                
                if(response.statusCode == 200){
                    setSubmitModalOpen(false);
        
                    setMessage("Successfully created the Logistics");
            
                    setIsOpenSweetAlert(true);
                    setSelectedVType(null);
                    setSelectedInvoice(null);
                    setPayload(null);
    
                }
            }
            catch (e){
                console.log(e)
                toast.error('Error in creating Purchase invoice')
            }
            finally {
                setIsLoading(false); // Reset loading state after operation completes
            }
        };
    
    const [inputValue, setInputValue] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);

    const addProductInvoiceRows = (result) => {
        if (result.length > 0) {
            const formattedProducts = result.map((product, index) => ({
            id: product.id, // Assuming index + 1 as ID
            Sl_No: index + 1, // Serial Number
            Product_No: product.item_no,
            Product_Name: product.item_name,
            Quantity: product.logistics_pending_qty,
            received_qty: '',
            remaining:product.logistics_pending_qty
            }));

            setApprovalrows(formattedProducts);
        }
      }


    useEffect(() => {
        setOptions({
            lr_no: '',
            lr_no_error: '',
            v_no: '',
            v_no_error: ''
        });
        setSelectedDutyFeesNumber(null);
        setApprovalrows([]);
        setDutyFeesList([]);
        if(selectedInvoice){
            if(selectedInvoice.v_type == "Import"){
            setDutyFeesList(selectedInvoice?.dutyFees);

            } else {
                addProductInvoiceRows(selectedInvoice?.products);
            }
            
        }
    }, [selectedInvoice, invoiceList]);

    useEffect(() => {
        setApprovalrows([]);
        if(selectedDutyFeesNumber){
            addProductInvoiceRows(selectedDutyFeesNumber?.procurementCustomsProducts);
        }
    }, [selectedDutyFeesNumber]);

    useEffect(() => {
        setSelectedInvoice(null)
    }, [selectedVType]);

    const handleSweetAlertConfirm = () => {
        setIsOpenSweetAlert(false);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        <Card>
                            <CardBody> 
                                <div>
                                <div className="d-flex align-items-center mb-2 gap-2">
                                            <p className='mb-0 me-2 requisition_type_text'>Logistic</p>
                                            <div>
                                            <Autocomplete
                                                className="invoice_autofield"
                                                // id={`product-category`}
                                                sx={{ width: 230 }}
                                                options={vTypeList}
                                                onChange={(e, value) => setSelectedVType(value)}
                                                value={selectedVType}
                                                // onChange={handleProductCategoryChange}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select Invoice No"
                                                    />
                                                )}
                                            />

                                        </div>
                                        <div>
                                            <Autocomplete
                                                className="invoice_autofield"
                                                // id={`product-category`}
                                                sx={{ width: 230 }}
                                                options={vTypeList}
                                                onChange={(e, value) => setSelectedVType(value)}
                                                value={selectedVType}
                                                // onChange={handleProductCategoryChange}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Duty Fee No"
                                                    />
                                                )}
                                            />

                                        </div>
                                        
                                            </div>
                                    {/* <div className='d-flex align-items-center  justify-content-between mb-2 gap-2'>
                                    
                                        <div className="d-flex align-items-center gap-2">
                                            <p className='mb-0 me-2 requisition_type_text'>Invoice No</p>
                                            <div>
                                            <Autocomplete
                                                className="invoice_autofield"
                                                // id={`product-category`}
                                                sx={{ width: 230 }}
                                                options={invoiceList}
                                                onChange={(e, value) => setSelectedInvoice(value)}
                                                value={selectedInvoice}
                                                // onChange={handleProductCategoryChange}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select Invoice No"
                                                    />
                                                )}
                                                disabled={!selectedVType}
                                            />

                                        </div>
                                        <div>
                                            <Autocomplete
                                                className="invoice_autofield"
                                                // id={`product-category`}
                                                sx={{ width: 230 }}
                                                disabled={!selectedInvoice || selectedInvoice.v_type == 'Domestic'}
                                                options={dutyFeesList}
                                                onChange={(e, value) => setSelectedDutyFeesNumber(value)}

                                                value={selectedDutyFeesNumber}
                                                // onChange={handleProductCategoryChange}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Duty Fees Number"
                                                    />
                                                )}
                                            />

                                        </div>
                                            </div>
                                    </div> */}
                                    <div className='d-flex align-items-center mb-2 gap-2 flex-wrap mt-3'>
                                        <div>
                                            <TextField
                                                className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="LR No"
                                                variant="outlined"
                                                value={options.lr_no}
                                                
                                                // disabled={row.productName == ''}
                                                onChange={(event) => handleInputChange(event.target.value, 'lr_no')}
                                                sx={{ width: 370 }}
                                            />

                                            {options.lr_no_error && <span className="error-message" style={{ color: 'red' }}>{options.lr_no_error}</span>}

                                        </div>
                                        <div>
                                            <TextField
                                                className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="Vehicle Number"
                                                variant="outlined"
                                                value={options.v_no}
                                                
                                                // disabled={row.productName == ''}
                                                onChange={(event) => handleInputChange(event.target.value, 'v_no')}
                                                sx={{ width: 370 }}
                                            />

                                            {options.v_no_error && <span className="error-message" style={{ color: 'red' }}>{options.v_no_error}</span>}

                                        </div>
                                        <div>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            className='payment_date date_picker_fullwidth'
                                            // value={selectedDate}
                                            // onChange={(e) => {
                                            //     setSelectedDate(e)
                                            // }}
                                            label="Pickup Date"
                                            sx={{ width: 300, background: 'white' }}
                                        />
                                    </LocalizationProvider>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-end">
                                          <button className="assign_vendor" disabled={!selectedInvoice || (selectedInvoice.v_type == 'Import' && !selectedDutyFeesNumber)} onClick={handleSubmit}>Submit</button>
                                        </div>
                                        {/* <div>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    className='invoice_datepicker'
                                                    label="Pickup Date"
                                                  value={dayjs(options.pickup_date)}
                                                onChange={(event) => handleInputChange(event, 'pickup_date')}
                                                  
                                                />
                                            </LocalizationProvider>
                                            {options.pickup_date_error && <span className="error-message" style={{ color: 'red' }}>{options.pickup_date_error}</span>}

                                        </div> */}
                                      
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <div>
                            <Box sx={{ height: "100%", width: '100%', marginBottom: '10px', marginTop: '8px' }}>
                                <DataGrid
                                    autoHeight
                                    className="table_header_background"
                                    headerClassName="custom-header-cell"
                                    getRowHeight={() => 'auto'}
                                    rows={approvalrows}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 5,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[5]}
                                    disableRowSelectionOnClick
                                    disableColumnMenu
                                    disableColumnResize={true}
                                    componentsProps={{
                                        cell: {
                                            disableClick: true,
                                        },
                                    }}
                                    sx={{
                                        '& .MuiDataGrid-cell': {
                                            '& .MuiDataGrid-cell--textOverflow': {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            },
                                        },
                                    }}
                                />
                            </Box>
                            {/* <div className="d-flex align-items-center justify-content-end">
                                <button className="assign_vendor" disabled={!selectedInvoice || (selectedInvoice.v_type == 'Import' && !selectedDutyFeesNumber)} onClick={handleSubmit}>Submit</button>
                           </div> */}
                        </div>
                    </div>
                </Container>
            </div>
            <Modal
                isOpen={isSubmitModalOpen}
                onRequestClose={() => setSubmitModalOpen(false)}
                contentLabel="Example Modal"
                className="change_modalbox generatePo_modal"
            >
                <div className='d-flex justify-content-between me-2 mt-3'>
                    <h4 className='ms-3'>Do you want to create this Logistic?</h4>
                    <div className='d-flex justify-content-end me-3 modal_close'>
                        <i class="ri-close-line" onClick={() => setSubmitModalOpen(false)}></i>
                    </div>
                </div>
                {/* <hr className='mb-2 mt-1 ms-3 me-3'></hr> */}
                <ModalBody className='pt-2'>
                    <div>
                    <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th>Sl No.</th>
                                            <th>Product</th>

                                            <th>Total Quantity</th>
                                            <th>Pickup Quantity</th>
                                            <th>Remaining</th>
                                        </tr>
                                    </thead>
                                    <tbody className='requisition_balance_table_body'>
                                        {payload?.logistics_product.map((row, index) => (
                                            <tr key={index}>
                                                <td>{++index}</td>
                                                <td>{row.item_name}</td>
                                                <td>{row.displayed_qty}</td>
                                                <td>{row.pickup_qty}</td>
                                                <td>{row.remaining_qty}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className='requisition_balance_footer'>
                                        <tr>
                                            <th id="total" colSpan="2">Total :</th>
                                            <td>{payload?.logistics_product.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.displayed_qty;
                                                }, 0)}</td>
                                            <td>{payload?.logistics_product.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.pickup_qty;
                                                }, 0)}</td>
                                            <td>{payload?.logistics_product.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.remaining_qty;
                                                }, 0)}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                    </div>
                    <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                        <button className="yes_button d-flex align-items-center" disabled={isLoading} onClick={submitRequisition}>
                            Yes
                        </button>
                        <button className="no_button d-flex align-items-center ms-3" onClick={() => setSubmitModalOpen(false)}>
                            No
                        </button>
                    </div>
                </ModalBody>
            </Modal>
            <SweetAlert
                show={isOpenSweetAlert}
                title={message}
                success
                confirmButtonText="Ok"
                confirmBtnBsStyle="success"
                onConfirm={handleSweetAlertConfirm} // Updated to handleSweetAlertConfirm function

            />
        </React.Fragment>
    );
};

export default Logistic;
